{getCurrentLocale} = require 'src/js/i18n'

class DateFilterBehaviour
    template: ->
        '''
        <div class="form-group">
            <select class="form-control">
                <option selected="selected" value="at">Am</option>
                <option value="between">Zeitraum</option>
                <option value="lessThanOrEqualTo">Bis zum</option>
                <option value="greaterThanOrEqualTo">Ab dem</option>
            </select>
        </div>
        <div class="form-group">
            <input class="form-control" type="text" name="from" placeholder="von">
        </div>
        <div class="form-group">
            <input class="form-control" type="text" name="to" placeholder="bis" disabled="disabled">
        </div>
        '''

    attachTo: (form) =>
        @form = form

        $(@form).find('select').on 'change', (event) =>
            $toInputBox = $(@form).find("input[name='to']")
            if $(@form).find('select').val() is 'between'
                $toInputBox.enable()
            else
                $toInputBox.val('')
                $toInputBox.disable()
        $(@form).find('input').datetimepicker
            format: 'L'
            locale: getCurrentLocale()

    isFilterSet: =>
        operation = $(@form).find('select').val()
        fromValue = $(@form).find("input[name='from']").data('DateTimePicker').date()
        toValue = $(@form).find("input[name='to']").data('DateTimePicker').date()
        fromValue and (not (operation is 'between') or toValue)

    getFilterString: (filterBuilder) =>
        operation = $(@form).find('select').val()
        fromValue = @adjustDate($(@form).find("input[name='from']").data('DateTimePicker').date()).format('YYYY-MM-DD')
        toValue = $(@form).find("input[name='to']").data('DateTimePicker').date()
        if not (toValue is null or toValue is undefined)
            toValue =  @adjustDate($(@form).find("input[name='to']").data('DateTimePicker').date()).format('YYYY-MM-DD')
        return filterBuilder operation, fromValue, toValue

    focus: =>
        $(@form).find("input[name='from']").focus()

    clear: =>
        $(@form).find('input').val('')
        $(@form).find("input[name='from']").data('DateTimePicker').clear()

    adjustDate: (dateToAdjust) ->
        moment(dateToAdjust).utc().add(dateToAdjust.utcOffset(), 'm')

module.exports = {DateFilterBehaviour}

module.exports.__esModule = true
module.exports.default = DateFilterBehaviour
